import React from 'react'
import FlexView from 'react-flexview/lib'
import { RadioGroup, FormControlLabel, Radio, Select, MenuItem, TextField } from '@material-ui/core'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'

const MAX_UAS = 10

export const CustomizeUASSection = () => {
    const offersContext = React.useContext(BuyingInsuranceContextStore)
    const [maximumText, setMaximumText] = React.useState(MAX_UAS + 1)
    const [usingTextField, setUsingTextField] = React.useState(MAX_UAS < offersContext.maximumUasInAir)
    
    const handleSelectChange = (event) => {
        setMaximumText(MAX_UAS + 1)
        offersContext.changeMaximumUAS(event.target.value)
        if(event.target.value > MAX_UAS) {
            setUsingTextField(true)
        }
        else{
            setUsingTextField(false)
        }
    }

    const handleTextChange = (event) => {
        setMaximumText(event.target.value)
        if(event.target.value > MAX_UAS) {
            offersContext.changeMaximumUAS(event.target.value)
        }
    }
    return (<React.Fragment>
        <FlexView vAlignContent={'center'}>
            <FlexView column>
                <FlexView vAlignContent={'center'} className="text-body bold black">Maximum number of UAS in the air at once</FlexView>
                <div className="text-body dark-grey margin-top-small">Select the maximum number of drones that could be flying at the same time </div>
            </FlexView>
            <Select onChange={handleSelectChange} value={usingTextField? 11 : offersContext.maximumUasInAir} variant="outlined" className="margin-left-basic">
                {[1,2,3,4,5,6,7,8,9,10].map(w => <MenuItem key={w} value={w}>{w}</MenuItem>)}
                {MAX_UAS < offersContext.maximumUasInAir ? <MenuItem key={11} value={11}>More than 10</MenuItem> : <MenuItem key={11} value={MAX_UAS + 1}>More than 10</MenuItem>}
            </Select>
            {usingTextField &&
                <TextField helperText={(!maximumText || maximumText <= MAX_UAS) && `Set a value of ${MAX_UAS} or more`} error={!maximumText || maximumText <= MAX_UAS} label={"Maximum number of UAS"} onChange={handleTextChange} className="margin-left-basic" value={maximumText} variant="outlined" />}
        </FlexView>
    </React.Fragment>
    )
}